import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.165 5.667c0-.46.373-.833.834-.833h2.5a.833.833 0 0 1 0 1.666h-2.5a.833.833 0 0 1-.834-.833m.834 2.5a.833.833 0 0 0 0 1.667h2.5a.833.833 0 0 0 0-1.667zm-.834 4.167c0-.46.373-.834.834-.834h2.5a.833.833 0 0 1 0 1.667h-2.5a.833.833 0 0 1-.834-.833M4.499 6.5a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666M5.332 9a.833.833 0 1 1-1.667 0 .833.833 0 0 1 1.667 0m-.833 4.167a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M.332 2.334c0-.92.746-1.667 1.667-1.667h10c.92 0 1.666.746 1.666 1.667v13.333c0 .92-.746 1.667-1.666 1.667h-10c-.92 0-1.667-.747-1.667-1.667zm11.667 0h-10v13.333h10z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }